import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { notificationDotStaticStyle } from './styles';
function NotificationDot(props) {
    return (_jsx("div", Object.assign({}, props, { css: notificationDotStaticStyle, "data-testid": "alert-dot" })));
}
export default NotificationDot;
